<template>
  <div>
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :columns="columnList"
        :customVisible="true"
        @dblclickEvent="dblclickEvent"
        @chooseClick="chooseClick"
        @currentChange="currentChange"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'creditType'">
              {{ creditTypeData[scope.row[item.field]] }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import tableMixins from '@/common/mixins/table.js';
  import SiruiTable from '@/components/SiruiTable';
  import { mapState } from 'vuex';
  export default {
    name: 'todo',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      SiruiTable,
    },
    data() {
      return {
        query: {
          businessNo: null,
          title: null,
          status: 'done',
        },
        menuButtonList: [],
        tableData: [],
        load: false,
        columnList: [],
        billTypeList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          { field: 'businessNo', title: '业务编号', sortable: true },
          { field: 'businessId', title: '业务id', sortable: true },
          { field: 'batchId', title: '批次号', sortable: true },
          { field: 'billTypeName', title: '单据类型', sortable: true },
          { field: 'operateTypeName', title: '操作类型' },
          { field: 'title', title: '标题' },
          { field: 'sendUserName', title: '发送人' },
          { field: 'sendTime', title: '发送时间' },
          { field: 'operatorName', title: '经办人' },
          { field: 'operateTime', title: '经办时间' },
        ],
        typeList: [],
        approvalConfigName: '', // 存放查询出的审批名字
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            type: 'select',
            name: '单据类型',
            prop: 'billType',
            options: this.billTypeList,
            changeMethod: 'billTypeChange',
          },
          {
            type: 'input',
            name: '业务编号',
            prop: 'businessNo',
            placeholder: '请输入业务编号',
          },
          {
            type: 'input',
            name: '标题',
            prop: 'title',
            placeholder: '请输入标题',
          },
          {
            type: 'input',
            name: '发送人',
            prop: 'sendUserName',
            placeholder: '请输入发送人',
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    async mounted() {
      await this.getApprovalConfig();
      console.log('已办===>approvalConfigName', this.approvalConfigName);
      console.log('已办===>personName', this.userInfo.personName);
      this.getData();
      this.getColumnInfo();
      this.getButtonList();
      this.loadList();
      this.getBillTypeList();
    },
    methods: {
      // 查询审批权限人
      async getApprovalConfig() {
        try {
          const response = await this.$axios.post('/component/approvalConfig/queryPage', {
            billType: 'managementStatistics',
            operateType: 'submit',
            pageNum: 1,
            pageSize: 10,
          });
          if (response.data.code === 0) {
            response.data.data.records.forEach((item) => {
              if (item.approverName == this.userInfo.personName) {
                this.approvalConfigName = item.approverName;
              }
            });
          } else {
            throw new Error(response.data.msg || '获取审批配置失败');
          }
        } catch (error) {
          console.error('获取审批配置时发生错误:', error);
        }
      },
      getBillTypeList() {
        const params = {
          enable: 1,
          pageNum: 1,
          pageSize: 99,
        };
        this.$axios.post('/component/approvalBillType/queryPage', params).then((res) => {
          if (res.data.code === 0) {
            let list = res.data.data.records || [];
            if (list.length > 0) {
              list.forEach((item) => {
                this.typeList.push({
                  billType: item.billType,
                  billTypeName: item.billTypeName,
                  route: item.route,
                });
              });
            }
          }
        });
      },
      loadList() {
        this.$axios
          .post('/component/approvalBillType/getSelectData')
          .then((res) => {
            this.billTypeList = res.data.data;
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: err.data.msg,
              type: 'error',
            });
          });
      },
      // 首次进入时调用此方法:获取经管部需要审批的数据
      getManagementStatisticsData() {
        // console.log('首次进入时调用此方法');
        console.log('已办===>进入managementStatisticsData');
        this.load = true;
        const params = this.$refs.siruiSearch.query;
        // const params = {};
        params.billType = 'managementStatistics';
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        // params.businessNo = this.$refs.siruiTable.businessNo;
        params.companyCode = '';
        params.departmentCode = '';
        params.searchOrderItems = [
          {
            asc: false,
            column: 'operate_time',
          },
        ];
        console.log('params{}', params);
        this.$axios.post('/component/approvalTask/queryPage', params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //获取数据
      /*getData() {
        this.load = true;
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.$axios.post('/component/approvalTask/queryPage', query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },*/
      getData() {
        this.load = true;
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        query.companyCode = this.userInfo.companyCode || '';
        query.departmentCode = this.userInfo.departmentCode || '';
        if (this.approvalConfigName == this.userInfo.personName) {
          this.getManagementStatisticsData();
        } else {
          this.$axios.post('/component/approvalTask/queryPage', query).then((res) => {
            this.load = false;
            console.log('已办===>不进入');
            if (0 == res.data.code) {
              this.tableData = res.data.data.records;
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        }
      },
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      chooseClick(type) {
        if (type === 'add') {
          this.$router.push('/todoCenter/approvalConfigAdd');
        } else if (type === 'edit') {
          this.$router.push('/todoCenter/approvalConfigEdit');
        }
      },
      currentChange(row) {
        console.log(row);
        // if (JSON.stringify(this.rowData) == '{}' || this.rowData?.id != row?.id) {
        //   this.rowData = row;
        // } else if (this.rowData?.id == row?.id) {
        //   this.rowData = {};
        // }
      },
      sortChangeEvent() {},
      dblclickEvent(value) {
        console.log(value, '已办===>双击');
        console.log(this.typeList, '已办===>this.typeList');
        console.log(value.row.billTypeName, '已办===>value.row.billTypeName');
        console.log(value.row.billType, '已办===>value.row.billType');
        if (this.typeList.length > 0) {
          this.typeList.forEach((item) => {
            if (
              item.billTypeName === value.row.billTypeName &&
              value.row.billType === 'managementStatistics'
            ) {
              let query = {
                // from: 'todo',
                from: 'done',
              };
              // 经管部统计审批
              query.id = value.row.businessId;
              query.status = 'detail';
              // 跳转
              let path = {
                path: item.route,
                name: 'JGB-managementStatistics',
                meta: {
                  keepAlive: false,
                  title: `${value.row.billTypeName}${value.row.businessNo}审批`,
                },
                query: query,
              };
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            }
            /*else if (item.billTypeName === value.row.billTypeName) {
              const routerArr = item.route ? item.route.split('/') : [];
              const pageName = routerArr ? routerArr[routerArr.length - 1] : '';
              let query = {
                from: 'todo',
              };
              if (value.row.billType === 'product') {
                // 商品
                query.propsGoodsId = value.row.businessId;
              } else if (value.row.billType === 'partners') {
                // 合作伙伴
                query.id = value.row.businessId || '20905';
                query.partnerCode = value.row.businessNo || 'HZHB0200004929';
              } else if (value.row.billType === 'service') {
                // 服务
                query.businessNo = value.row.businessNo || '';
              } else if (value.row.billType === 'storage') {
                // 仓库
                console.log(item, '仓库');
                query.rowId = value.row.businessId || '';
              } else if (value.row.billType == 'superviseContract') {
                // 如果当前用户不属于以上几家公司的时候不能点击
                const contractCompanyCodeList = this.contractCompanyList.map((item) => item.value);
                if (!contractCompanyCodeList.includes(this.userInfo.companyCode)) {
                  this.$message.error('当前公司不支持该操作');
                  return;
                }
                query.id = value.row.businessId;
                query.contractNo = value.row.businessNo;
                query.status = 'detail';
              } else if (value.row.billType == 'superviseBill') {
                // 监管单审核
                console.log(value.row, '审批代办行数据');
                query.id = value.row.businessId;
                query.approvalType = value.row.operateTypeName;
                query.operateType = value.row.operateType;
                query.status = 'approval';
              } else if (value.row.billType == 'space') {
                // 空间资产审核
                query.id = value.row.businessId;
                query.isAudit = true;
              } else if (value.row.billType == 'electricPrice') {
                // 片区电价审核
                query.type = 'approval';
                query.id = value.row.businessId;
              } else if (value.row.billType == 'electricMeter') {
                // 电表审核
                query.type = 'approval';
                query.id = value.row.businessId;
              } else if (value.row.billType == 'waterPrice') {
                // 片区水价审核
                query.type = 'approval';
                query.id = value.row.businessId;
              } else if (value.row.billType == 'waterMeter') {
                // 水表审核
                query.type = 'approval';
                query.id = value.row.businessId;
              } else if (value.row.billType == 'repair') {
                // 报修单审核
                query.pageMode = 3;
                query.repairId = value.row.businessId;
              } else if (value.row.billType == 'contractInfo') {
                // 仓储合同审核
                query.pageMode = 2;
                query.id = value.row.businessId;
              } else if (value.row.billType == 'leaseContract') {
                // 租赁合同
                query.contractId = value.row.businessId;
                query.type = 'audit';
              }

              // 跳转
              let path = {
                path: item.route,
                // name: 'JGB-managementStatistics',
                name: pageName,
                meta: {
                  keepAlive: false,
                  title: `${value.row.billTypeName}${value.row.businessNo}审批`,
                },
                query: query,
              };
              // return;
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            }*/
          });
        }
      },
    },
  };
</script>

<style scoped></style>
